var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('meeting-display-menu'),_c('booking-display-menu'),_c('event-display-menu'),(_vm.temp)?_c('task-display-menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }